import Vue from 'vue';
import WidgetFrame from 'src/components/widgets/WidgetFrame/WidgetFrame.vue';
import icon from 'assets/img/dashboards/dash-context-network.svg';
import errorIcon from 'assets/icons/alert-bubble.svg';
import DownloadExportButton from 'components/project/analysis/results/widgets/DownloadExportButton.vue';
import NetworkLayout from "components/project/analysis/results/widgets/NetworkLayout.vue";
export default Vue.extend({
    components: { WidgetFrame, DownloadExportButton, NetworkLayout },
    props: {
        /** data to render */
        data: { type: Object, required: false, default: null },
        exportName: { type: String, required: false, default: '' },
        /** `fetching`, `done` or `''` */
        status: { type: String, required: false, default: '' },
        /** error object for dev panel */
        error: { type: [Error, Object], required: false, default: null },
        /** nicer error message for user  */
        userError: { type: String, required: false, default: null },
        startTime: { type: Number, required: false, default: null },
        doneTime: { type: Number, required: false, default: null },
        devMode: { type: Boolean, required: false, default: false },
        /** widget banner to display */
        banner: { type: Object, default: () => null, required: false },
        minConcepts: { type: Number, default: 3, required: false },
        noDataMsg: { type: String, default: 'Not enough data for network', required: false },
        height: { type: Number, default: 450, required: false },
        query: { type: Object, required: false, default: null },
        /** Add a skeleton mask (used when reloading state between dashboards) */
        masked: { type: Boolean, required: false, default: false },
        /** The title of the current view so that we can use it in the
         * interaction menu. Should be something like "store & prices" */
        viewTitle: { type: String, required: false, default: '' },
    },
    data() {
        return {
            icon,
            isNetworkDrawn: false,
            errorIcon,
        };
    },
    computed: {
        isLoading() {
            return this.status === 'fetching';
        },
        hasErrored() {
            return this.error !== null;
        },
        isInsufficientData() {
            const len = this.model?.concepts?.length || 0;
            return len < this.minConcepts;
        },
        model() {
            return this.data?.model;
        }
    },
    watch: {
        query() {
            this.fetchData();
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        refresh() {
            window.location.reload();
        },
        contact() {
            try {
                window.Intercom('show');
            }
            catch (e) {
                console.warn('intercom show failed');
            }
        },
        reload() {
            this.fetchData(true);
        },
        getExportConfig() {
            return this.$refs.networkLayout.getExportConfig();
        },
        getNetworkEl() {
            return this.$el.querySelector('.network-wrapper svg');
        },
        fetchData(force = false) {
            this.$emit('requires', 'context-network', {
                query: this.query,
                options: {
                    num_network_concepts: 25,
                },
            }, force);
        },
        async makePptSlide(pptx) {
            const slide = pptx.addSlide();
            // Unfortunately our PPTX library doesn't seem to preserve aspect ratio.
            // The sizing types it provides are supposed to adjust the image while
            // preserving aspect ratio but they didn't seem to work as documented.
            // So, here we are simply calculating the aspect ratio from the root
            // element of the context network. This element is passed into the image
            // generation code.
            const bbox = this.getNetworkEl().getBoundingClientRect();
            const aspectRatio = bbox.width / bbox.height;
            slide.addImage({
                data: await this.$refs.exportButton.generateImageData('image/png'),
                x: 1.25,
                y: 0.8,
                w: 4 * aspectRatio,
                h: 4
            });
        },
    },
});
